import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Example module - you can create separate modules as needed
const store = createStore({
  state: {
    // Add your state properties here
    user: null,
    token: null
  },
  mutations: {
    // Add your mutations here
    SET_USER(state, user) {
      state.user = user
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    CLEAR_AUTH(state) {
      state.user = null
      state.token = null
    }
  },
  actions: {
    // Add your actions here
    setUser({ commit }, user) {
      commit('SET_USER', user)
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  },
  getters: {
    // Add your getters here
    isAuthenticated: (state) => !!state.token,
    currentUser: (state) => state.user
  },
  plugins: [
    createPersistedState({
      // Configuration options
      // Only persist specific paths (optional - remove to persist all state)
      // paths: ['user', 'token'],
      
      // Storage key (default: 'vuex')
      key: 'vuex',
      
      // Storage type: localStorage (default) or sessionStorage
      storage: window.localStorage
    })
  ]
})

export default store

